import React, { Component } from 'react';
import { Switch, Spin, Tooltip, Modal, Button, Icon, Pagination, Avatar, notification, Empty } from 'antd';
import { UndoOutlined, CloseOutlined, UserOutlined } from '@ant-design/icons';
import { CSVLink } from "react-csv";
import { consentpatientSchema, investigationsSchema, proceduresSchema, drugsSchema } from '../../../schema/bill-tacking';
import Select2 from '../../../components/FormComponent/select2';
import Inputlayer from '../../../components/FormComponent/Input';
import DateRange from '../../../components/FormComponent/DateRange';

import moment from 'moment';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import Add_more_table from '../../../components/FormComponent/add-more-table';
import Select2multiple from '../../../components/FormComponent/select2/multiple';

const {homepage} = networkList;

let { getConsentPatientsList, getConsentsDetailsForPatient, consentSubmitFromCounsellor, addCounsellorComments } = networkList;
let i = 0;
class Consent_Patients_List extends Component {
    csvLink = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            'loadding': false,
            'page_data_count': 1,
            'search_key': '',
            previlege_data: [],
            responseData: [],
            tableHead: [],
            page_length: 20,
            'total_items': 0,
            dateTo: moment().format('YYYY-MM-DD'),
            dateFrom: moment().subtract(7, 'd').format('YYYY-MM-DD'),
            'downloadtbody': [],
            downloadStatus: 0,
            tbody: [],
            patient_details: {},
            commentsArray: [],
            commentModal: false,
            investigations: JSON.parse(JSON.stringify(investigationsSchema['feilds'])),
            procedures: JSON.parse(JSON.stringify(proceduresSchema['feilds'])),
            drugs: JSON.parse(JSON.stringify(drugsSchema['feilds'])),
            investigations_head: [
                {
                    'id': 1,
                    'text': 'S.No.',
                    'name': 's_no',
                    'visible': true,
                    'className': 'text-center'
                },
                {
                    'id': 2,
                    'text': 'Investigation Name',
                    'name': 'investigation_name',
                    'visible': true,
                    'className': 'text-center'
                },
                {
                    'id': 3,
                    'text': 'General Price (Rs.)',
                    'name': 'general_price',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 4,
                    'text': 'Price (Rs.)',
                    'name': 'price',
                    'visible': true,
                    'className': null
                }, {
                    'id': 5,
                    'text': 'Status',
                    'name': 'approval_status',
                    'visible': true,
                    'className': null
                }, {
                    'id': 6,
                    'text': 'Declined Reason',
                    'name': 'reject_reason',
                    'visible': true,
                    'className': null
                }, {
                    'id': 7,
                    'text': 'Created Date',
                    'name': 'created_at',
                    'visible': true,
                    'className': null
                }
            ],
            investigations_body: [],
            drug_head: [
                {
                    'id': 1,
                    'text': 'S.No.',
                    'name': 's_no',
                    'visible': true,
                    'className': 'text-center'
                },
                {
                    'id': 2,
                    'text': 'Drug Name',
                    'name': 'drug_name',
                    'visible': true,
                    'className': 'text-center'
                }, {
                    'id': 3,
                    'text': 'Quantity',
                    'name': 'quantity',
                    'visible': true,
                    'className': null
                }, {
                    'id': 3,
                    'text': 'General Price (Rs.)',
                    'name': 'drug_price',
                    'visible': true,
                    'className': null
                }, {
                    'id': 3,
                    'text': 'Price (Rs.)',
                    'name': 'price',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 4,
                    'text': 'Status',
                    'name': 'approval_status',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 5,
                    'text': 'Declined Reason',
                    'name': 'reject_reason',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 6,
                    'text': 'Created Date',
                    'name': 'created_at',
                    'visible': true,
                    'className': null
                }
            ],
            durg_body: [],
            procedures_head: [
                {
                    'id': 1,
                    'text': 'S.No.',
                    'name': 's_no',
                    'visible': true,
                    'className': 'text-center'
                },
                {
                    'id': 2,
                    'text': 'Procedures Name',
                    'name': 'procedure_name',
                    'visible': true,
                    'className': 'text-center'
                },
                {
                    'id': 3,
                    'text': 'General Price (Rs.)',
                    'name': 'general_price',
                    'visible': true,
                    'className': null
                }, {
                    'id': 4,
                    'text': 'Price (Rs.)',
                    'name': 'price',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 5,
                    'text': 'Status',
                    'name': 'approval_status',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 6,
                    'text': 'Declined Reason',
                    'name': 'reject_reason',
                    'visible': true,
                    'className': null
                },
                {
                    'id': 7,
                    'text': 'Created Date',
                    'name': 'created_at',
                    'visible': true,
                    'className': null
                }
            ],
            procedures_body: [],
            viewModal: false,
            patient_name:''
        }
    }

    componentDidMount() {
        let tableHead = [{
            'key': 'ip_no',
            'text': 'IP number'
        }, 
        {
            'key': 'consent_id',
            'text': 'Consent ID'
        },
        {
            'key': 'created_at',
            'text': 'Consent Request Date'
        },
        {
            'key': 'umr_no',
            'text': 'UMR number'
        }, {
            'key': 'patient_name',
            'text': 'Patient Name'
        }, {
            'key': 'nurse',
            'text': 'nurse'
        },
        {
            'key': 'nurse_station_name',
            'text': 'Nurse Station'
        },
        {
            'key': 'is_counsellor_submitted',
            'text': 'Counsellor submitted ?'
        }, {
            'key': 'counsellor',
            'text': 'counsellor'
        },
        {
            'key': 'doctor_name',
            'text': 'Doctor Name'
        }, 
        {
            'key': 'department_name',
            'text': 'Department Name'
        },
        {
            'key': 'payer_type',
            'text': 'Payer Type'
        },
        {
            'key': 'counsellor_submit_date',
            'text': 'counsellor submit date'
        },
    ];
        let formSchema = Object.assign({}, consentpatientSchema);
        formSchema['feilds'].map((feild, key) => {
            if (feild.name === 'doctorid') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Doctor';
            } else if (feild.name === 'departmentbyunit') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Department';
            } else if (feild.name === 'payer_type') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Payer Type';
            } 
            else if ( feild.name === 'nursestationbyunit') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Nurse Station';
            }
            else if( feild.name === 'counsellor_submitted'){
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Counsellor Submitted';
            }
           else{
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                delete formSchema['feilds'][key]['text'];
            }
            

        })
        this.setState((state) => ({ 'tableHead': tableHead, search_key: '' ,'formData': formSchema['feilds']}), () => {
            this.renderBody();
        })

    }

    renderBody() {
        i = 0;

        let { page_data_count,doctor_id, department_name, payer_type, search_key, nurse_station_code, counsellor_submitted} = this.state;
        this.setState((state) => ({ loadding: true, download_btn: true, downloadStatus: 0 }));
        let This = this;
        try {
            let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            let counsellor_submit_type_value = ''
            if(counsellor_submitted){
                if(counsellor_submitted.length>1){
                    counsellor_submit_type_value = 'all'
                }else{
                    counsellor_submit_type_value = counsellor_submitted[0]
                }
            }else{
                counsellor_submit_type_value = null
            }
            postService(getConsentPatientsList, 'POST', {
                'data': {
                    "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                    'page_no': page_data_count,
                    "search_key": search_key,
                    "doctor_id": doctor_id ? doctor_id : [],
                    "department_name": department_name ? department_name : [],
                    "payer_type": payer_type ? payer_type : [],
                    "from": search_key ? '' : moment(this.state.dateFrom).format('YYYY-MM-DD'),
                    "to":  search_key ? '' : moment(this.state.dateTo).format('YYYY-MM-DD'),
                    "nurse_station_code": nurse_station_code ? nurse_station_code : [],
                    "counsellor_submitted":counsellor_submit_type_value,
                    // "doctor_id": [],
                    // "department_name": [],
                    // "payer_type": []
                }
            }).then(res => {
                this.setState((state) => ({ loadding: false }));
                if (res.status) {
                    if (res.data && Array.isArray(res['data']) && res['data'].length !== 0) {
                        this.setState((state) => ({ 'tbody': res['data'], 'total_items': res['total_items'] }))
                        // enable downloadbtn after 2sec
                        setTimeout(function () {
                            This.setState((state) => ({ downloadStatus: 1 }))
                        }, 2000);
                    } else {
                        this.setState((state) => ({ 'tbody': [], 'total_items': 0 }))

                    }
                } else {
                    if (res === 401) {

                    } else {
                        Modal.error({
                            title: 'Failure',
                            content: "Oops! something went wrong... Please try again.",
                        });
                    }

                }
            })


        } catch (error) {
            this.setState((state) => ({ loadding: false }));
        }
    }

    navigateTo(body) {
        let { umr, unit_id } = body
        this.props.history.push(`/patients/patients-history-details?umr=${umr}&unit_id=${unit_id}`);

    }



    pageChange(data) {
        this.setState((state) => ({ 'page_data_count': data }), () => {
            this.renderBody();
        })
    }

    searchClick() {
        i = 0;
        this.setState((state) => ({ 'page_data_count': 1 }), () => {
            this.renderBody();
        })
    }


    searchChange(e) {
        console.log(e.target.value);
        let value = e.target.value
        i = 0;
        this.setState((state) => ({ 'search_key': value }), () => {

        });
    }

    itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    }

    indexIncrement() {
        i = i + 1;
    }
    dateRange = () => {
        this.setState((state) => ({
            activePage: 1,
            totalItemsCount: 0,
            page_data_count: 1,
            search_key: ''
        }), () => {
            this.inputRef.value = null;
            this.renderBody(true);
        })
    }
    downloadFile() {
        i = 0;
        let { getConsentPatientsList } = networkList;
        let { page_data_count, search_key,doctor_id, department_name, payer_type, nurse_station_code} = this.state;
        this.setState((state) => ({ loadding: true, download_btn: true, downloadStatus: 0 }));
        let This = this;
        try {
            let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            let dwntablehead =[{
                'key': 'ip_no',
                'text': 'IP number'
            }, {
                'key': 'umr_no',
                'text': 'UMR number'
            }, {
                'key': 'patient_name',
                'text': 'Patient Name'
            }, {
                'key': 'nurse',
                'text': 'nurse'
            }, {
                'key': 'is_counsellor_submitted',
                'text': 'Counsellor submitted ?'
            }, {
                'key': 'counsellor',
                'text': 'counsellor'
            },
            {
                'key': 'doctor_name',
                'text': 'Doctor Name'
            }, 
            {
                'key': 'department_name',
                'text': 'Department Name'
            },
            {
                "key": 'nurse_station_name',
                'label': 'Nurse Station'
            },
            {
                'key': 'payer_type',
                'text': 'Payer Type'
            },
            {
                'key': 'counsellor_submit_date',
                'text': 'counsellor submit date'
            },
            {
                'key': 'counsellor_submit_date',
                'text': 'Consent Request Data & Time'
            }
        ];
            This.setState((state) => ({ downloadStatus: 0, downloadthead: dwntablehead, filename: 'Consent Patients-List.csv', download_btn: true, loadding: true }), () => {
                postService(getConsentPatientsList, 'POST', {
                    'data': {
                        "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                        'page_no': page_data_count,
                        "search_key": search_key,
                        "doctor_id": doctor_id ? doctor_id : [],
                        "department_name": department_name ? department_name : [],
                        "from": search_key ? '' : moment(this.state.dateFrom).format('YYYY-MM-DD'),
                        "to":  search_key ? '' : moment(this.state.dateTo).format('YYYY-MM-DD'),
                        "payer_type": payer_type ? payer_type : [],
                        "nurse_station_code": nurse_station_code ? nurse_station_code : []
                    }
                }).then(res => {
                    console.log('tat report:', res.data);
                    if (res.status) {
                        if (res.data && Array.isArray(res['data']) && res['data'].length !== 0) {
                            This.setState((state) => ({ downloadStatus: 1, downloadtbody: res['data'] ? res['data'] : [], loadding: false }));
                            this.csvLink.current.link.click();
                        }

                    } else {
                        if (res === 401) {

                        } else {
                            Modal.error({
                                title: 'Failure',
                                content: "Oops! something went wrong... Please try again.",
                            });
                        }
                    }
                });
            });

        } catch (error) {
            this.setState((state) => ({ loadding: false }));
        }
    }

    commentsModals = (data) => {
        console.log(data)
        let This = this
        let user_data
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        try {
            This.setState((state) => ({ commentModal: true, patient_details: data, loadding: true }), () => {
                postService(getConsentsDetailsForPatient, 'POST', {
                    "data": {
                        "consent_id": data.consent_id ? data.consent_id : null
                    }
                }).then(res => {
                    console.log('comments:', res);
                    if (res.status) {
                        This.setState((state) => ({ 'loadding': false, 'commentsArray': res['data']['investigations'] }));
                    } else {
                        This.setState((state) => ({ 'loadding': false, 'commentsArray': [] }));
                        Modal.error({
                            title: 'Failure',
                            content: res.message ? res.message : "Oops! something went wrong... Please try again.",
                            zIndex: 1022
                        });
                    }
                });
            });
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
                zIndex: 1022
            });
        }
        this.getSubTasksdetails(data)
    }
    commentsModal(data) {
        let { investigations, procedures, drugs } = this.state
        if (data.is_counsellor_submitted) {
            this.setState((state) => ({ viewModal: true, patient_details: data, loadding: true }));
            try {
                postService(getConsentsDetailsForPatient, 'POST', { 'data': { "consent_id": data.consent_id ? data.consent_id : null } }).then(res => {
                    if (res.status === true) {
                        this.setState((state) => ({
                            loadding: false,
                            investigations_body: res["data"].investigations,
                            durg_body: res['data'].drugs,
                            procedures_body: res['data'].procedures,
                            patient_details:res['data'],
                            patient_name:data.patient_name
                        }));
                    } else {
                        this.setState({
                            loadding: false, 
                            viewModal: false,
                            investigations_body: [],
                            durg_body: [],
                            procedures_body: []
                        })
                        Modal.error({
                            title: 'Failure',
                            content: res.message ? res.message : 'Oops! something is wrong. Please try again.',
                        })
                    }
                })
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ loadding: false, viewModal: false }));

                Modal.error({
                    title: 'Failure',
                    content: 'Oops, something is wrong. Please try again.',
                })

            }
        } else {
            investigations.map((data, secKey) => {
                data['Specification']['table_body'] = [];
            })
            procedures.map((data, secKey) => {
                data['Specification']['table_body'] = [];
            })
            drugs.map((data, secKey) => {
                data['Specification']['table_body'] = [];
            })
            // console.log('checking:', investigations)
            // let investigations = JSON.parse(JSON.stringify(investigationsSchema['feilds']))
            this.setState((state) => ({ commentModal: true, patient_details: data, loadding: true }));
            try {
                postService(getConsentsDetailsForPatient, 'POST', { 'data': { "consent_id": data.consent_id ? data.consent_id : null } }).then(res => {
                    if (res.status === true) {
                        let investigations_flow = res['data']['investigations']
                        // let investigations_flow = []                    
                        if (investigations_flow) {

                            investigations.map((data, secKey) => {
                                let obj = {}
                                investigations_flow.map((packages, packages_key) => {
                                    // let investigations = packages['investigations']                               
                                    if (true) {
                                        obj = {
                                            'id': 1,
                                            'key_word': 'Services',
                                            'feilds': [{
                                                id: packages['id'],
                                                pid: 'a' + packages['id'],
                                                investigation_id: packages['investigation_id'],
                                                service: 1,
                                                sub_header: 1,
                                                name: 'name',
                                                title: packages['investigation_name'],
                                                visible: true,
                                                element: 'text',
                                                row_group: 'room',
                                                table: 'services',
                                            }, {
                                                id: packages['id'],
                                                pid: 'a' + packages['id'],
                                                investigation_id: packages['investigation_id'],
                                                name: 'status',
                                                title: 'Status',
                                                visible: true,
                                                icon: 'number',
                                                element: 'radio',
                                                required: true,
                                                type: 'radio',
                                                placeholder: 'Status',
                                                rules: [{
                                                    test: (value) => {
                                                        return (value !== null && value.length > 0 && value != '');
                                                    },
                                                    message: 'Select Status'
                                                }],
                                                data: [{
                                                    id: packages['id'],
                                                    pid: 'a' + packages['id'],
                                                    investigation_id: packages['investigation_id'], id: 1,
                                                    pid: 'a' + packages['id'],
                                                    name: 'approve',
                                                    title: 'Approve',
                                                    visible: true,
                                                    icon: 'number',
                                                    element: 'radio',
                                                    required: true,
                                                    type: 'radio',
                                                    placeholder: 'Approve',
                                                    rules: [],
                                                    errors: [],
                                                    value: null,
                                                    valid: false,
                                                    state: '',
                                                    disable: false,
                                                    className: 'col-3',
                                                    row_group: 'room',
                                                    table: 'services',
                                                }, {
                                                    id: packages['id'],
                                                    pid: 'a' + packages['id'],
                                                    investigation_id: packages['investigation_id'],
                                                    name: 'reject',
                                                    title: 'Reject',
                                                    visible: true,
                                                    icon: 'number',
                                                    element: 'radio',
                                                    required: true,
                                                    type: 'radio',
                                                    placeholder: 'Reject',
                                                    rules: [],
                                                    errors: [],
                                                    value: null,
                                                    valid: false,
                                                    state: '',
                                                    disable: false,
                                                    className: 'col-3',
                                                    row_group: 'room',
                                                    table: 'services',
                                                }],
                                                errors: [],
                                                value: null,
                                                valid: false,
                                                state: '',
                                                disable: false,
                                                className: 'col-3',
                                                row_group: 'room',
                                                table: 'services',
                                            }, {
                                                id: packages['id'],
                                                pid: 'a' + packages['id'],
                                                investigation_id: packages['investigation_id'],
                                                name: 'consent_reason',
                                                title: 'Reason',
                                                visible: true,
                                                icon: 'number',
                                                element: 'select',
                                                required: true,
                                                type: 'select',
                                                placeholder: 'Reason',
                                                rules: [{
                                                    test: (value) => {
                                                        return (value !== null && value.length > 0 && value != '');
                                                    },
                                                    message: 'Select Reason'
                                                }],
                                                errors: [],
                                                value: null,
                                                valid: false,
                                                state: '',
                                                disable: true,
                                                className: 'col-3',
                                                row_group: 'room',
                                                table: 'services',
                                            },{
                                                id: packages['id'],
                                                pid: 'a' + packages['id'],
                                                investigation_id: packages['investigation_id'],
                                                name: 'general_price',
                                                title: 'General Price',
                                                visible: true,
                                                icon: 'number',
                                                element: 'input',
                                                required: true,
                                                type: 'number',
                                                placeholder: 'Amount',
                                                rules: [{
                                                    test: (value) => {
                                                        return (value !== null && value.length > 0 && value != '');
                                                    },
                                                    message: 'Enter Amount'
                                                }],
                                                errors: [],
                                                value: packages['general_price'],
                                                valid: false,
                                                state: '',
                                                disable: true,
                                                className: 'col-3',
                                                row_group: 'room',
                                                table: 'services',
                                            },
                                             {
                                                id: packages['id'],
                                                pid: 'a' + packages['id'],
                                                investigation_id: packages['investigation_id'],
                                                name: 'price',
                                                title: 'Price',
                                                visible: true,
                                                icon: 'number',
                                                element: 'input',
                                                required: true,
                                                type: 'number',
                                                placeholder: 'Amount',
                                                rules: [{
                                                    test: (value) => {
                                                        return (value !== null && value.length > 0 && value != '');
                                                    },
                                                    message: 'Enter Amount'
                                                }],
                                                errors: [],
                                                value: packages['price'],
                                                valid: false,
                                                state: '',
                                                disable: true,
                                                className: 'col-3',
                                                row_group: 'room',
                                                table: 'services',
                                            }, 
                                        ]
                                        }

                                    }
                                    data['Specification']['table_body'].push(obj);
                                })
                            })
                        }
                        // console.log('yes:', investigations)
                        // procedures
                        let procedures_flow = res['data']['procedures']
                        // let procedures_flow = []                    
                        if (procedures_flow) {
                            procedures.map((data, secKey) => {
                                let obj = {}
                                procedures_flow.map((packages, packages_key) => {
                                    // let procedures = packages['procedures']                               
                                    if (true) {
                                        obj = {
                                            'id': 1,
                                            'key_word': 'Procedures',
                                            'feilds': [{
                                                id: packages['id'],
                                                pid: 'a' + packages['id'],
                                                procedure_id: packages['procedure_id'],
                                                service: 1,
                                                sub_header: 1,
                                                name: 'name',
                                                title: packages['procedure_name'],
                                                visible: true,
                                                element: 'text',
                                                row_group: 'room',
                                                table: 'procedures',
                                            }, {
                                                id: packages['id'],
                                                pid: 'a' + packages['id'],
                                                procedure_id: packages['procedure_id'],
                                                name: 'status',
                                                title: 'Status',
                                                visible: true,
                                                icon: 'number',
                                                element: 'radio',
                                                required: true,
                                                type: 'radio',
                                                placeholder: 'Status',
                                                rules: [{
                                                    test: (value) => {
                                                        return (value !== null && value.length > 0 && value != '');
                                                    },
                                                    message: 'Select Status'
                                                }],
                                                data: [{
                                                    id: packages['id'],
                                                    pid: 'a' + packages['id'],
                                                    procedure_id: packages['procedure_id'],
                                                    name: 'approve',
                                                    title: 'Approve',
                                                    visible: true,
                                                    icon: 'number',
                                                    element: 'radio',
                                                    required: true,
                                                    type: 'radio',
                                                    placeholder: 'Approve',
                                                    rules: [],
                                                    errors: [],
                                                    value: null,
                                                    valid: false,
                                                    state: '',
                                                    disable: false,
                                                    className: 'col-3',
                                                    row_group: 'room',
                                                    table: 'procedures',
                                                }, {
                                                    id: packages['id'],
                                                    pid: 'a' + packages['id'],
                                                    procedure_id: packages['procedure_id'],
                                                    name: 'reject',
                                                    title: 'Reject',
                                                    visible: true,
                                                    icon: 'number',
                                                    element: 'radio',
                                                    required: true,
                                                    type: 'radio',
                                                    placeholder: 'Reject',
                                                    rules: [],
                                                    errors: [],
                                                    value: null,
                                                    valid: false,
                                                    state: '',
                                                    disable: false,
                                                    className: 'col-3',
                                                    row_group: 'room',
                                                    table: 'procedures',
                                                }],
                                                errors: [],
                                                value: null,
                                                valid: false,
                                                state: '',
                                                disable: false,
                                                className: 'col-3',
                                                row_group: 'room',
                                                table: 'procedures',
                                            }, {
                                                id: packages['id'],
                                                pid: 'a' + packages['id'],
                                                procedure_id: packages['procedure_id'],
                                                name: 'consent_reason',
                                                title: 'Reason',
                                                visible: true,
                                                icon: 'number',
                                                element: 'select',
                                                required: true,
                                                type: 'select',
                                                placeholder: 'Reason',
                                                rules: [{
                                                    test: (value) => {
                                                        return (value !== null && value.length > 0 && value != '');
                                                    },
                                                    message: 'Select Reason'
                                                }],
                                                errors: [],
                                                value: null,
                                                valid: false,
                                                state: '',
                                                disable: true,
                                                className: 'col-3',
                                                row_group: 'room',
                                                table: 'procedures',
                                            }, {
                                                id: packages['id'],
                                                pid: 'a' + packages['id'],
                                                investigation_id: packages['investigation_id'],
                                                name: 'general_price',
                                                title: 'General Price',
                                                visible: true,
                                                icon: 'number',
                                                element: 'input',
                                                required: true,
                                                type: 'number',
                                                placeholder: 'Amount',
                                                rules: [{
                                                    test: (value) => {
                                                        return (value !== null && value.length > 0 && value != '');
                                                    },
                                                    message: 'Enter Amount'
                                                }],
                                                errors: [],
                                                value: packages['general_price'],
                                                valid: false,
                                                state: '',
                                                disable: true,
                                                className: 'col-3',
                                                row_group: 'room',
                                                table: 'services',
                                            },{
                                                id: packages['id'],
                                                pid: 'a' + packages['id'],
                                                procedure_id: packages['procedure_id'],
                                                name: 'price',
                                                title: 'Price',
                                                visible: true,
                                                icon: 'number',
                                                element: 'input',
                                                required: true,
                                                type: 'number',
                                                placeholder: 'Amount',
                                                rules: [{
                                                    test: (value) => {
                                                        return (value !== null && value.length > 0 && value != '');
                                                    },
                                                    message: 'Enter Amount'
                                                }],
                                                errors: [],
                                                value: packages['price'],
                                                valid: false,
                                                state: '',
                                                disable: true,
                                                className: 'col-3',
                                                row_group: 'room',
                                                table: 'procedures',
                                            }]
                                        }

                                    }
                                    data['Specification']['table_body'].push(obj);
                                })
                            })
                        }
                        // drugs
                        let drugs_flow = res['data']['drugs']
                        // let drugs_flow = []                    
                        if (drugs_flow) {
                            drugs.map((data, secKey) => {
                                let obj = {}
                                drugs_flow.map((packages, packages_key) => {
                                    // let drugs = packages['drugs']                               
                                    if (true) {
                                        obj = {
                                            'id': 1,
                                            'key_word': 'drugs',
                                            'feilds': [{
                                                id: packages['id'],
                                                pid: 'a' + packages['id'],
                                                drug_id: packages['drug_id'],
                                                service: 1,
                                                sub_header: 1,
                                                name: 'name',
                                                title: packages['drug_name'],
                                                visible: true,
                                                element: 'text',
                                                row_group: 'room',
                                                table: 'drugs',
                                            }, {
                                                id: packages['id'],
                                                pid: 'a' + packages['id'],
                                                drug_id: packages['drug_id'],
                                                name: 'status',
                                                title: 'Status',
                                                visible: true,
                                                icon: 'number',
                                                element: 'radio',
                                                required: true,
                                                type: 'radio',
                                                placeholder: 'Status',
                                                rules: [{
                                                    test: (value) => {
                                                        return (value !== null && value.length > 0 && value != '');
                                                    },
                                                    message: 'Select Status'
                                                }],
                                                data: [{
                                                    id: packages['id'],
                                                    pid: 'a' + packages['id'],
                                                    drug_id: packages['drug_id'],
                                                    name: 'approve',
                                                    title: 'Approve',
                                                    visible: true,
                                                    icon: 'number',
                                                    element: 'radio',
                                                    required: true,
                                                    type: 'radio',
                                                    placeholder: 'Approve',
                                                    rules: [],
                                                    errors: [],
                                                    value: null,
                                                    valid: false,
                                                    state: '',
                                                    disable: false,
                                                    className: 'col-3',
                                                    row_group: 'room',
                                                    table: 'drugs',
                                                }, {
                                                    id: packages['id'],
                                                    pid: 'a' + packages['id'],
                                                    drug_id: packages['drug_id'],
                                                    name: 'reject',
                                                    title: 'Reject',
                                                    visible: true,
                                                    icon: 'number',
                                                    element: 'radio',
                                                    required: true,
                                                    type: 'radio',
                                                    placeholder: 'Reject',
                                                    rules: [],
                                                    errors: [],
                                                    value: null,
                                                    valid: false,
                                                    state: '',
                                                    disable: false,
                                                    className: 'col-3',
                                                    row_group: 'room',
                                                    table: 'drugs',
                                                }],
                                                errors: [],
                                                value: null,
                                                valid: false,
                                                state: '',
                                                disable: false,
                                                className: 'col-3',
                                                row_group: 'room',
                                                table: 'drugs',
                                            }, {
                                                id: packages['id'],
                                                pid: 'a' + packages['id'],
                                                drug_id: packages['drug_id'],
                                                name: 'consent_reason',
                                                title: 'Reason',
                                                visible: true,
                                                icon: 'number',
                                                element: 'select',
                                                required: true,
                                                type: 'select',
                                                placeholder: 'Reason',
                                                rules: [{
                                                    test: (value) => {
                                                        return (value !== null && value.length > 0 && value != '');
                                                    },
                                                    message: 'Select Reason'
                                                }],
                                                errors: [],
                                                value: null,
                                                valid: false,
                                                state: '',
                                                disable: true,
                                                className: 'col-3',
                                                row_group: 'room',
                                                table: 'drugs',
                                            },{
                                                id: packages['id'],
                                                pid: 'a' + packages['id'],
                                                drug_id: packages['drug_id'],
                                                name: 'quantity',
                                                title: 'Quantity',
                                                visible: true,
                                                icon: 'number',
                                                element: 'input',
                                                required: true,
                                                type: 'number',
                                                placeholder: 'Quantity',
                                                rules: [{
                                                    test: (value) => {
                                                        return (value !== null && value.length > 0 && value != '');
                                                    },
                                                    message: 'Enter Quantity'
                                                }],
                                                errors: [],                                                
                                                value: packages['quantity'],
                                                valid: false,
                                                state: '',
                                                disable: true,
                                                className: 'col-3',
                                                row_group: 'room',
                                                table: 'drugs',
                                            },  {
                                                id: packages['id'],
                                                pid: 'a' + packages['id'],
                                                drug_id: packages['drug_id'],
                                                name: 'price',
                                                title: 'Price',
                                                visible: true,
                                                icon: 'number',
                                                element: 'input',
                                                required: true,
                                                type: 'number',
                                                placeholder: 'Amount',
                                                rules: [{
                                                    test: (value) => {
                                                        return (value !== null && value.length > 0 && value != '');
                                                    },
                                                    message: 'Enter Amount'
                                                }],
                                                errors: [],
                                                value: packages['drug_price'],
                                                valid: false,
                                                state: '',
                                                disable: true,
                                                className: 'col-3',
                                                row_group: 'room',
                                                table: 'drugs',
                                            }, {
                                                id: packages['id'],
                                                pid: 'a' + packages['id'],
                                                drug_id: packages['drug_id'],
                                                name: 'total_amount',
                                                title: 'Total Amount',
                                                visible: true,
                                                icon: 'number',
                                                element: 'input',
                                                required: true,
                                                type: 'number',
                                                placeholder: 'Amount',
                                                rules: [{
                                                    test: (value) => {
                                                        return (value !== null && value.length > 0 && value != '');
                                                    },
                                                    message: 'Enter Amount'
                                                }],
                                                errors: [],
                                                value: (packages['quantity']*packages['drug_price']),
                                                valid: false,
                                                state: '',
                                                disable: true,
                                                className: 'col-3',
                                                row_group: 'room',
                                                table: 'drugs',
                                            }]
                                        }

                                    }
                                    data['Specification']['table_body'].push(obj);
                                })
                            })
                        }
                        // console.log('now:', investigations)
                        this.setState((state) => ({
                            message: res.message,
                            loadding: false,
                            investigations: investigations,
                            patient_details:res['data'],
                            patient_name:data.patient_name
                        }));
                    } else {
                        this.setState({ loadding: false, investigations: [] })
                        Modal.error({
                            title: 'Failure',
                            content: res.message ? res.message : 'Oops! something is wrong. Please try again.',
                        })
                    }
                })
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ loadding: false, investigations: [] }));

                Modal.error({
                    title: 'Failure',
                    content: 'Oops, something is wrong. Please try again.',
                })

            }
        }
    }
    handleChange(ele) {
        let { investigations, procedures, drugs } = this.state

        investigations.map((subTable, key) => {
            if (subTable.title === ele.tableName) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let feildss = feild.feilds;
                    let rate, qty = null;
                    feildss.map((sub_feild, sub_table_key) => {

                        if (sub_feild.name === 'consent_reason') {
                            if (ele.name === "approve" && sub_feild.pid === ele.parentID) {
                                investigations[key].Specification.table_body[table_key].feilds[2]["value"] = null
                                investigations[key].Specification.table_body[table_key].feilds[2]["text"] = null
                                investigations[key].Specification.table_body[table_key].feilds[2]["disable"] = true
                            } else if (ele.name === "reject" && sub_feild.pid === ele.parentID) {
                                investigations[key].Specification.table_body[table_key].feilds[2]["value"] = null
                                investigations[key].Specification.table_body[table_key].feilds[2]["text"] = null
                                investigations[key].Specification.table_body[table_key].feilds[2]["disable"] = false
                            }
                        }
                        if (sub_feild.name === 'price') {
                            if (ele.name === "approve" && sub_feild.pid === ele.parentID) {
                                // investigations[key].Specification.table_body[table_key].feilds[4]["value"] = null
                                // investigations[key].Specification.table_body[table_key].feilds[4]["text"] = null
                                investigations[key].Specification.table_body[table_key].feilds[4]["disable"] = true
                            } else if (ele.name === "reject" && sub_feild.pid === ele.parentID) {
                                // investigations[key].Specification.table_body[table_key].feilds[4]["value"] = null
                                // investigations[key].Specification.table_body[table_key].feilds[4]["text"] = null
                                investigations[key].Specification.table_body[table_key].feilds[4]["disable"] = true
                            }
                        }
                        if (ele.name === 'price' && sub_feild.pid === ele.parentID) {
                            investigations[key].Specification.table_body[table_key].feilds[4]["value"] = ele.value
                        }
                        if (sub_feild.name === 'status') {

                            let radioData = sub_feild.data
                            radioData.map((sub_feild2, sub_table_key2) => {
                                if (sub_feild2.pid === ele.parentID) {
                                    investigations[key].Specification.table_body[table_key].feilds[1]['value'] = ele.value
                                }

                                if (ele.name === "approve") {
                                    if (sub_feild2.name === "approve" && sub_feild2.pid === ele.parentID) {
                                        investigations[key].Specification.table_body[table_key].feilds[sub_table_key]['data'][sub_table_key2]["value"] = 'approve'
                                        investigations[key].Specification.table_body[table_key].feilds[sub_table_key]['data'][1]["value"] = null
                                    }
                                } else if (ele.name === "reject") {
                                    if (sub_feild2.name === "reject" && sub_feild2.pid === ele.parentID) {
                                        investigations[key].Specification.table_body[table_key].feilds[sub_table_key]['data'][sub_table_key2]["value"] = 'reject'
                                        investigations[key].Specification.table_body[table_key].feilds[sub_table_key]['data'][0]["value"] = null
                                    }
                                }
                            })
                        }
                    })
                })
            }
        })
        procedures.map((subTable, key) => {

            if (subTable.title === ele.tableName) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let feildss = feild.feilds;
                    let rate, qty = null;
                    feildss.map((sub_feild, sub_table_key) => {

                        if (sub_feild.name === 'consent_reason') {
                            if (ele.name === "approve" && sub_feild.pid === ele.parentID) {
                                // procedures[key].Specification.table_body[table_key].feilds[2]["value"] = null
                                // procedures[key].Specification.table_body[table_key].feilds[2]["text"] = null
                                procedures[key].Specification.table_body[table_key].feilds[2]["disable"] = true
                            } else if (ele.name === "reject" && sub_feild.pid === ele.parentID) {
                                procedures[key].Specification.table_body[table_key].feilds[2]["value"] = null
                                procedures[key].Specification.table_body[table_key].feilds[2]["text"] = null
                                procedures[key].Specification.table_body[table_key].feilds[2]["disable"] = false
                            }
                        }
                        if (sub_feild.name === 'price') {
                            if (ele.name === "approve" && sub_feild.pid === ele.parentID) {
                                // procedures[key].Specification.table_body[table_key].feilds[4]["value"] = null
                                // procedures[key].Specification.table_body[table_key].feilds[4]["text"] = null
                                procedures[key].Specification.table_body[table_key].feilds[4]["disable"] = true
                            } else if (ele.name === "reject" && sub_feild.pid === ele.parentID) {
                                // procedures[key].Specification.table_body[table_key].feilds[4]["value"] = null
                                // procedures[key].Specification.table_body[table_key].feilds[4]["text"] = null
                                procedures[key].Specification.table_body[table_key].feilds[4]["disable"] = true
                            }
                        }
                        if (ele.name === 'price' && sub_feild.pid === ele.parentID) {
                            procedures[key].Specification.table_body[table_key].feilds[4]["value"] = ele.value
                        }
                        if (sub_feild.name === 'status') {

                            let radioData = sub_feild.data
                            radioData.map((sub_feild2, sub_table_key2) => {
                                if (sub_feild2.pid === ele.parentID) {
                                    procedures[key].Specification.table_body[table_key].feilds[1]['value'] = ele.value
                                }
                                if (ele.name === "approve") {
                                    if (sub_feild2.name === "approve" && sub_feild2.pid === ele.parentID) {
                                        procedures[key].Specification.table_body[table_key].feilds[sub_table_key]['data'][sub_table_key2]["value"] = 'approve'
                                        procedures[key].Specification.table_body[table_key].feilds[sub_table_key]['data'][1]["value"] = null
                                    }
                                } else if (ele.name === "reject") {
                                    if (sub_feild2.name === "reject" && sub_feild2.pid === ele.parentID) {
                                        procedures[key].Specification.table_body[table_key].feilds[sub_table_key]['data'][sub_table_key2]["value"] = 'reject'
                                        procedures[key].Specification.table_body[table_key].feilds[sub_table_key]['data'][0]["value"] = null
                                    }
                                }
                            })
                        }
                    })
                })
            }
        })
        drugs.map((subTable, key) => {

            if (subTable.title === ele.tableName) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let feildss = feild.feilds;
                    let rate, qty = null;
                    feildss.map((sub_feild, sub_table_key) => {

                        if (sub_feild.name === 'consent_reason') {
                            if (ele.name === "approve" && sub_feild.pid === ele.parentID) {
                                // drugs[key].Specification.table_body[table_key].feilds[2]["value"] = null
                                // drugs[key].Specification.table_body[table_key].feilds[2]["text"] = null
                                drugs[key].Specification.table_body[table_key].feilds[2]["disable"] = true
                            } else if (ele.name === "reject" && sub_feild.pid === ele.parentID) {
                                drugs[key].Specification.table_body[table_key].feilds[2]["value"] = null
                                drugs[key].Specification.table_body[table_key].feilds[2]["text"] = null
                                drugs[key].Specification.table_body[table_key].feilds[2]["disable"] = false
                            }
                        }
                        // if (sub_feild.name === 'price') {
                        //     if (ele.name === "approve" && sub_feild.pid === ele.parentID) {
                        //         drugs[key].Specification.table_body[table_key].feilds[4]["value"] = 0
                        //         drugs[key].Specification.table_body[table_key].feilds[4]["text"] = null
                        //         drugs[key].Specification.table_body[table_key].feilds[4]["disable"] = false
                        //     } else if (ele.name === "reject" && sub_feild.pid === ele.parentID) {
                        //         drugs[key].Specification.table_body[table_key].feilds[4]["value"] = 0
                        //         drugs[key].Specification.table_body[table_key].feilds[4]["text"] = null
                        //         drugs[key].Specification.table_body[table_key].feilds[4]["disable"] = true
                        //     }
                        // }
                        // if (ele.name === 'price' && sub_feild.pid === ele.parentID) {
                        //     drugs[key].Specification.table_body[table_key].feilds[4]["value"] = ele.value
                        // }
                        if (sub_feild.name === 'status') {

                            let radioData = sub_feild.data
                            radioData.map((sub_feild2, sub_table_key2) => {
                                if (sub_feild2.pid === ele.parentID) {
                                    drugs[key].Specification.table_body[table_key].feilds[1]['value'] = ele.value
                                }
                                if (ele.name === "approve") {
                                    if (sub_feild2.name === "approve" && sub_feild2.pid === ele.parentID) {
                                        drugs[key].Specification.table_body[table_key].feilds[sub_table_key]['data'][sub_table_key2]["value"] = 'approve'
                                        drugs[key].Specification.table_body[table_key].feilds[sub_table_key]['data'][1]["value"] = null
                                    }
                                } else if (ele.name === "reject") {
                                    if (sub_feild2.name === "reject" && sub_feild2.pid === ele.parentID) {
                                        drugs[key].Specification.table_body[table_key].feilds[sub_table_key]['data'][sub_table_key2]["value"] = 'reject'
                                        drugs[key].Specification.table_body[table_key].feilds[sub_table_key]['data'][0]["value"] = null
                                    }
                                }
                            })
                        }
                    })
                })
            }
        })
        this.setState((state) => ({ 'investigations': investigations, 'procedures': procedures, 'drugs': drugs }));
        // console.log('sai', procedures)
    }
    deleteRow(data) {
        let { addonSchema, additionalPackageSchema, additionalProcedureSchema } = this.state;

        let table_name = data[0].feilds[0].table;
        let last_id = data[0].feilds[0].id;

        if (Array.isArray(data)) {
            addonSchema.map((subTable, key) => {
                if (subTable.name === table_name) {
                    let table_body = subTable.Specification.table_body;
                    table_body.map((feild, table_key) => {
                        if (feild.id === last_id) {
                            addonSchema[key].Specification.table_body.splice(table_key, 1);
                        }
                    })
                }
            })
        }
        this.setState({ addonSchema: addonSchema }, () => {
            // this.total_suming();
        })
    }

    submitConsent = () => {
        let { investigations, procedures, drugs, patient_details } = this.state
        let investigations_array = [];
        let procedures_array = [];
        let drugs_array = [];

        investigations.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let id, investigation_id, title, approval_status, reason_id, price;
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name !== 'name') {
                            id = sub_feild.id
                            investigation_id = sub_feild.investigation_id
                            if (sub_feild.name === 'status') {
                                approval_status = sub_feild['data'][0]['value'] || sub_feild['data'][1]['value'] || null;
                            }
                            if (sub_table_key === 2) {
                                reason_id = sub_feild.value ? parseInt(sub_feild.value) : null;
                            }
                            if (sub_table_key === 3) {
                                price = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                            }
                        }else {
                            title = sub_feild.title
                        }
                    })
                    let obj = {
                        'id': id,
                        'investigation_id': investigation_id,
                        'approval_status': approval_status,
                        'reason_id': reason_id,
                        'price': price,
                        'title': title
                        // percentage : percentage
                    }
                    if (id && investigation_id && approval_status) {
                        investigations_array.push(obj);
                    }
                })
            }
        })
        // console.log('submit', investigations_array)
        procedures.map((subTable, key) => {
            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let id, procedure_id, title, approval_status, reason_id, price;
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name !== 'name') {
                            id = sub_feild.id
                            procedure_id = sub_feild.procedure_id
                            if (sub_feild.name === 'status') {
                                approval_status = sub_feild['data'][0]['value'] || sub_feild['data'][1]['value'] || null;
                            }
                            if (sub_table_key === 2) {
                                reason_id = sub_feild.value ? parseInt(sub_feild.value) : null;
                            }
                            if (sub_table_key === 3) {
                                price = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                            }
                        }else {
                            title = sub_feild.title
                        }
                    })
                    let obj = {
                        'id': id,
                        'procedure_id': procedure_id,
                        'approval_status': approval_status,
                        'reason_id': reason_id,
                        'price': price,
                        'title': title
                        // percentage : percentage
                    }
                    if (id && procedure_id && approval_status) {
                        procedures_array.push(obj);
                    }
                })
            }
        })
        // console.log('submit2:', procedures_array)
        drugs.map((subTable, key) => {

            if (subTable.visible) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let id, drug_id, title, approval_status, reason_id, price, total_amount;
                    let row = feild.feilds;
                    row.map((sub_feild, sub_table_key) => {
                        if (sub_feild.name !== 'name') {
                            id = sub_feild.id
                            drug_id = sub_feild.drug_id
                            if (sub_feild.name === 'status') {
                                approval_status = sub_feild['data'][0]['value'] || sub_feild['data'][1]['value'] || null;
                            }
                            if (sub_table_key === 2) {
                                reason_id = sub_feild.value ? parseInt(sub_feild.value) : null;
                            }
                            if (sub_table_key === 5) {
                                total_amount = sub_feild.value ? parseFloat(sub_feild.value) : 0;
                            }
                        }else {
                            title = sub_feild.title
                        }
                    })
                    let obj = {
                        'id': id,
                        'drug_id': drug_id,
                        'approval_status': approval_status,
                        'reason_id': reason_id,
                        'price': total_amount,
                        'title': title
                        // percentage : percentage
                    }
                    if (id && drug_id && approval_status) {
                        drugs_array.push(obj);
                    } else {
                        // console.log('testing:', id, drug_id)
                    }
                })
            }
        })
        // console.log('submit3:', drugs_array)
        let error = this.validateModalFeilds(investigations)
        let error2 = this.validateModalFeilds2(procedures)
        let error3 = this.validateModalFeilds3(drugs)
        let This = this
        let payload = {
            "consent_id": patient_details.consent_id ? patient_details.consent_id : null,
            "investigations": investigations_array,
            "procedures": procedures_array,
            "drugs": drugs_array
        }
        // console.log('payload', payload)        
        // return
        if (!error.includes(false) && !error2.includes(false) && !error3.includes(false)) {
            try {
                This.setState((state) => ({ loadding: true }), () => {
                    postService(consentSubmitFromCounsellor, 'POST', {
                        "data": payload
                    }).then(res => {
                        console.log('comments:', res);
                        if (res.status) {
                            This.setState((state) => ({ 'loadding': false, commentModal: false }));
                            Modal.success({
                                title: 'Success',
                                content: res.message ? res.message : "Successfully updated.",
                                zIndex: 1022
                            });
                            This.consentsasRemarks(investigations_array,procedures_array,drugs_array)
                            
                        } else {
                            This.setState((state) => ({ 'loadding': false, commentModal: false }));
                            Modal.error({
                                title: 'Failure',
                                content: res.message ? res.message : "Oops! something went wrong... Please try again.",
                                zIndex: 1022
                            });
                        }
                    });
                });
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ 'loadding': false }));
                Modal.error({
                    title: 'Failure',
                    content: "Oops, something went wrong... Please try again.",
                    zIndex: 1022
                });
            }
        } else {
            // alert('fail')
        }
    }
    validateModalFeilds(formFeilds) {

        let errors = [];
        let role_id = null;

        formFeilds.map((subTable, key) => {
            if (subTable.title) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let feildss = feild.feilds;
                    feildss.map((feild, fkey) => {
                        if ((feild['element'] === 'input' || feild['element'] === 'select') || feild['element'] === 'radio') {
                            formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'] = [];
                            if (!feild.disable && feild.visible) {
                                feild.rules.map((rule, rkey) => {
                                    if ((feild['value'] === null) || feild['value'] === '' || (feild['value'] === undefined)) {
                                        formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'].push({ 'message': rule.message });
                                        errors.push(false);
                                    }
                                    else {
                                        formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'] = [];
                                        errors.push(true);
                                    }
                                })
                            }
                        }
                    })
                })
            }
        })
        console.log('error', formFeilds)
        this.setState((state) => ({ investigations: formFeilds }));
        return errors;
    }
    validateModalFeilds2(formFeilds) {

        let errors = [];
        let role_id = null;

        formFeilds.map((subTable, key) => {
            if (subTable.title) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let feildss = feild.feilds;
                    feildss.map((feild, fkey) => {
                        if ((feild['element'] === 'input' || feild['element'] === 'select') || feild['element'] === 'radio') {
                            formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'] = [];
                            if (!feild.disable && feild.visible) {
                                feild.rules.map((rule, rkey) => {
                                    if ((feild['value'] === null) || feild['value'] === '' || (feild['value'] === undefined)) {
                                        formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'].push({ 'message': rule.message });
                                        errors.push(false);
                                    }
                                    else {
                                        formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'] = [];
                                        errors.push(true);
                                    }
                                })
                            }
                        }
                    })
                })
            }
        })
        console.log('error2', formFeilds)
        this.setState((state) => ({ procedures: formFeilds }));
        return errors;
    }
    validateModalFeilds3(formFeilds) {

        let errors = [];
        let role_id = null;

        formFeilds.map((subTable, key) => {
            if (subTable.title) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let feildss = feild.feilds;
                    feildss.map((feild, fkey) => {
                        if ((feild['element'] === 'input' || feild['element'] === 'select') || feild['element'] === 'radio') {
                            formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'] = [];
                            if (!feild.disable && feild.visible) {
                                feild.rules.map((rule, rkey) => {
                                    if ((feild['value'] === null) || feild['value'] === '' || (feild['value'] === undefined)) {
                                        formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'].push({ 'message': rule.message });
                                        errors.push(false);
                                    }
                                    else {
                                        formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'] = [];
                                        errors.push(true);
                                    }
                                })
                            }
                        }
                    })
                })
            }
        })
        console.log('error2', formFeilds)
        this.setState((state) => ({ drugs: formFeilds }));
        return errors;
    }
    submit() {
        var formFeilds = this.state.formData;
        let { search } = this.state
        this.setState(({ doctor_id: formFeilds[0].value, department_name: formFeilds[1].value,payer_type: formFeilds[2].value,nurse_station_code:formFeilds[4].value,counsellor_submitted: formFeilds[5].value, search_key: '',activePage: 1, }), () => {
            this.inputRef.value = null;
            this.renderBody()
        })
    }
    clearFilter = () => {
        this.setState(() => ({ doctor_id: '', department_name: '', payer_type: '',counsellor_submitted:'', bill_value: '', nurse_station_code: '',ward_type: '', search_key: '', activePage: 1, totalItemsCount: 0 }),
            () => {
                this.inputRef.value = null;
                var formFeilds = this.state.formData;
                formFeilds.map((feild, key) => {
                    if (feild.name === 'doctorid') {
                        formFeilds[key]['value'] = [];
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Doctor';
                    } else if (feild.name === 'departmentbyunit') {
                        formFeilds[key]['value'] = [];
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Department';
                    } else if (feild.name === 'payer_type') {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Payer Type';
                    }
                    else if ( feild.name === 'nursestationbyunit') {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Nurse Station';
                    } 
                    else if (feild.name === 'counsellor_submitted') {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Counsellor Submitted';
                    }
                    else if (feild.name === '"search"') {
                            formFeilds[key]['value'] = null;
                            formFeilds[key]['valid'] = false;
                            formFeilds[key]['errors'] = [];
                            formFeilds[key]['text'] = 'Patient Name or UMR or IP';
                    }else{
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        delete formFeilds[key]['text'];
                    }
                })
                this.setState({ formData: formFeilds })
                this.renderBody();
            })

    }

    consentsasRemarks = (investigations_array, procedures_array, drugs_array) => {
        investigations_array && investigations_array.length > 0 && investigations_array.map((data, key) => {
            this.apicallforconsentRemarks(data)
        })
        procedures_array && procedures_array.length > 0 && procedures_array.map((data, key) => {
            this.apicallforconsentRemarks(data)
        })
        drugs_array && drugs_array.length > 0 && drugs_array.map((data, key) => {
            this.apicallforconsentRemarks(data)
        })
        this.renderBody()
    }

    apicallforconsentRemarks = (data) => {
        let This = this
        let { patient_details } = this.state
        let userData = localStorage.getItem('user_data');
        if (userData !== undefined && userData !== null && userData !== '') {
            userData = JSON.parse(userData);
        } else {
            userData = null
        }
        let payload ={
            "data": {
                "ip_no": (patient_details && patient_details.ip_no) ? patient_details.ip_no : null,
                "umr_no": (patient_details && patient_details.umr_no) ? patient_details.umr_no : null,
                "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                "comment": `${data.title} consent is ${(data.approval_status == 'approve') ? 'approved.' : 'rejected.'}`,
                "comment_from": "consent"
            }
        }
        // return
        try {
            This.setState((state) => ({ loadding: true }), () => {
                postService(addCounsellorComments, 'POST', payload).then(res => {
                    console.log('comments:', res);
                    if (res.status) {
                        This.setState((state) => ({ 'loadding': false, }));
                    } else {
                        This.setState((state) => ({ 'loadding': false, }));
                        // Modal.error({
                        //     title: 'Failure',
                        //     content: res.message ? res.message : "Oops! something went wrong... Please try again.",
                        //     zIndex: 1022
                        // });
                    }
                });
            });
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            // Modal.error({
            //     title: 'Failure',
            //     content: "Oops, something went wrong... Please try again.",
            //     zIndex: 1022
            // });
        }
    }
    render() {
        let { tbody, tableHead, previlege_data, total_items, page_data_count, page_length, activePage, loadding, commentModal, investigations, procedures, patient_details, drugs, investigations_head, investigations_body, drug_head, durg_body, procedures_head, procedures_body, viewModal,formData ,patient_name,downloadStatus,downloadtbody,thead,filename} = this.state;
        return (
            <div>
                <div className="clearfix mx-5">
                <div className="float-left pt-2">
                Consent Patients
                </div>
                {/* {
                        downloadStatus && tbody != ''
                            ? */}
                            {/* <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">
                                <button className="btn btn-success text-capitalize" onClick={() => { this.downloadFile() }}><img src="/assets/images/icons/download1.png" alt="" className="pr-2" /> <span> Download Report</span></button>
                                <CSVLink data={downloadtbody} headers={thead} filename={filename} className="hidden" ref={this.csvLink} />
                                <button className="btn btn-light text-capitalize py-1 mr-3" onClick={() => { this.clearFilter() }}><UndoOutlined className="align-middle pr-2" /><span> Clear</span></button>
                                <button className="btn btn-success text-capitalize mr-3" onClick={() => { this.submit() }}><span>Submit</span></button>
                            </div>
                            : */}
                            <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">
                                {/* <Button className="btn btn-success-disabled text-capitalize" disabled><img src="/assets/images/icons/download1.png" alt="" className="pr-2" /><span> Download Report</span></Button> */}
                                <button className="btn btn-light text-capitalize py-1 mr-3 " onClick={() => { this.clearFilter() }}><UndoOutlined type="reload" className="align-middle pr-2" /><span> Clear</span></button>
                                <Button className="btn btn-success text-capitalize mr-3" onClick={() => { this.submit() }}><span>Submit</span></Button>
                            </div>
                    {/* } */}
                {/* <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse"> 
                <button className="btn btn-success text-capitalize mr-3" onClick={() => { this.submit()}}><span>Submit</span></button>
                <button className="btn btn-light text-capitalize py-1 mr-3" onClick={() => { this.clearFilter() }}><UndoOutlined  className="align-middle pr-2" /><span> Clear</span></button> */}

                {/* </div> */}
                </div>
                <div className="card ml-5 mr-5 mb-5 card-table">
                    <div className="card-header bg8">
                        <div className="clearfix">
                            <div className=" row">
                            {(formData !== undefined) &&  <React.Fragment>
                                {formData.map((feild, key) => {
                                        if (feild.element === 'input' && feild.visible) {
                                            return (
                                                <div className="col-3 mx-auto">
                                                    <div class="input-group">
                                                        <input type="text" id="myInput" class="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder={feild.placeholder} onBlur={this.searchChange.bind(this)} ref={(inputRef => (this.inputRef = inputRef))} />
                                                        <div class="input-group-append">
                                                            <button class="btn btn-primary btn-sm" type="button" onClick={this.searchClick.bind(this)}><img src={homepage+"/assets/images/icons/search.png"}></img></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        if (feild.element === 'daterange') {
                                            return (
                                                <div
                                                    className={`${feild.className
                                                        ? feild.className
                                                        : 'col '} ${feild.name}`}
                                                    key={key}>
                                                    {/* <p className="data-label text-white mb-1 pt-1 text-right pr-2">{feild.text}: </p> */}

                                                    <DateRange
                                                        Queuedata={formData}
                                                        selectdata={feild}
                                                        {...this.props}
                                                        {...this.state}
                                                        onselectChanges={(e) => { console.log('onselectChanges:', e.value[0]); this.setState({ dateFrom: e.value[0], dateTo: e.value[1] }); }}
                                                    />
                                                    <div class="input-group-append">
                                                        <button class="btn btn-primary btn-sm ml-1" onClick={() => { this.dateRange() }}>Go</button>
                                                    </div>
                                                    {/* ,()=>this.renderBody() */}
                                                </div>
                                            )
                                        }
                                        if (feild.element === 'select2' && feild.visible) {
                                            return (
                                                <React.Fragment key={key}>
                                                    {(feild.name === 'patient_list' && feild.disable === false) &&
                                                        <div className="col-6">
                                                            <p className="mb-0 text-black pl-0" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="text-info" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> Please Select Patient List</p>
                                                        </div>}
                                                    <div
                                                        className={`${feild.className
                                                            ? feild.className
                                                            : 'col '} ${feild.name}`}
                                                        key={key}>
                                                        <p className="data-label text-white w-25 mb-1 pt-1 text-right pr-2">{feild.text2}</p>
                                                        <Select2
                                                            Queuedata={formData}
                                                            selectdata={feild}
                                                            {...this.props}
                                                            {...this.state}
                                                        /> {feild
                                                            .errors
                                                            .map((error, eKey) => {
                                                                return (
                                                                    <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                );
                                                            })}
                                                    </div>
                                                </React.Fragment>
                                            )
                                        }
                                        if (feild.element === 'select2multiple' && feild.visible) {
                                            return (
                                                <React.Fragment key={key}>                                                            
                                                    <div
                                                        className={`${feild.className
                                                            ? feild.className
                                                            : 'col '} ${feild.name}`}
                                                        key={key}>
                                                        <Select2multiple
                                                            Queuedata={formData}
                                                            selectdata={feild}
                                                            {...this.props}
                                                            {...this.state}
                                                            onselectChanges={this
                                                                .handleChange
                                                                .bind(this, feild)}
                                                        /> {feild
                                                            .errors
                                                            .map((error, eKey) => {
                                                                return (
                                                                    <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                );
                                                            })}
                                                    </div>
                                                </React.Fragment>
                                            )
                                        }
                                    })}
                                    </React.Fragment>
    }
                            </div>
                        </div>
                    </div>

                    <div className="financial-table table-responsive sticky-header" id="table">
                        <table className="table table-hover table-bordered mb-0 bg-white" style={{ width: '120%' }}>
                            <thead>
                                <tr>
                                    <td style={{ width: '80px' }}>S.no</td>
                                    {tableHead.map((head, key) => {
                                        if(head.text==='Consent ID'){
                                            return (<td key={key} style={{ width: '102px' }}>{head.text}</td>);
                                        }else{
                                            return (<td key={key} >{head.text}</td>);
                                        }
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {tbody.map((body, key) => {
                                    return (<tr key={key}>
                                        <td>{(key + 1) + (page_data_count > 1 ? 20 * (page_data_count > 2 ? (page_data_count - 1) : 1) : 0)}</td>
                                        {tableHead.map((head, Hkey) => {

                                            if (head['key'] === 'counsellor_submit_date') {
                                                return (<td>{body['counsellor_submit_date'] ? moment(body['counsellor_submit_date']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                            }
                                            if (head['key'] === 'ip_no') {
                                                return (
                                                    <td className="text-capitalize"><p style={{ 'cursor': 'pointer', 'color': 'blue' }} onClick={() => { this.commentsModal(body) }}>{body[head['key']] ? body[head['key']] : 'NA'}</p></td>
                                                )
                                            }
                                            if (head['key'] === 'is_counsellor_submitted') {
                                                return (
                                                    <td className="text-capitalize">{body[head['key']] === 1 ? 'YES' : 'NO'}</td>
                                                )
                                            }
                                            return (
                                                <td key={Hkey} className="text-capitalize">
                                                  {head['key'] === 'created_at' && body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm',) : body[head['key']] || 'NA'}
                                                </td>
                                              );
                                            // return (
                                            //     <td className="text-capitalize">{(body[head['key']] !== null) ? body[head['key']] : 'NA'}</td>
                                            // )

                                        })
                                        }

                                    </tr>)
                                })}
                                {(tbody && tbody.length === 0) && <React.Fragment>

                                    <tr>
                                        <td colSpan={tableHead.length + 1} className="text-center">
                                            <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                            <p className="no-data mb-0">No Data</p>
                                        </td>
                                    </tr>

                                </React.Fragment>}
                            </tbody>
                        </table>
                    </div>
                </div>
                {(this.state.loadding) &&
                    <div className="loadding"> <Spin tip="Loading..." size={'large'}></Spin></div>}
                <div className="col-6 offset-3 text-center mb-5">
                    <Pagination current={page_data_count} total={total_items} itemRender={this.itemRender.bind(this)} pageSize={page_length} showSizeChanger={false} onChange={this.pageChange.bind(this)} />
                </div>
                <Modal
                    title=''
                    centere
                    footer={null}
                    width='95%'
                    zIndex='1021'
                    closable={false}
                    maskClosable={false}
                    visible={commentModal}>
                    <Spin spinning={loadding}>
                        <Tooltip title="Close"><CloseOutlined type="close" className="comments-popup-close" onClick={() => this.setState({ commentModal: false, comments: null })} /></Tooltip>
                        <h4 className="text-center pb-4">Consent Edit</h4>
                        <div className="row pb-3">
                            <div className="col-12 my-auto p-0">
                                <h6 className="mb-0"> <Tooltip title="Patient Name">{patient_details.patient_name ? patient_details.patient_name : patient_name}</Tooltip> <span className="mx-3">|</span> <Tooltip title="UMR Number">{patient_details.umr_no ? patient_details.umr_no : '--'}</Tooltip> <span className="mx-3">|</span> <Tooltip title="IP Number">{patient_details.ip_no ? patient_details.ip_no : '--'}</Tooltip>
                                <span className="mx-3">|</span><Tooltip title="Ward Name">{patient_details.ward_name ? patient_details.ward_name : '--'}</Tooltip> <span className="mx-3">|</span><Tooltip title="Nurse Station Name">{patient_details.nurse_station_name ? patient_details.nurse_station_name : '--'}</Tooltip></h6>
                            </div>
                        </div>
                        <div className="row">
                            {investigations.map((feild, key) => {
                                if (feild.visible) {
                                    return (<React.Fragment key={key}>
                                        <div className="d-inline-flex w-100">
                                            <h4 className="data-label w-50" style={{ fontSize: 20 }}>{feild.title}</h4>
                                            {/* <h4 className="data-label w-50 text-right mr-3" style={{ fontSize: 20 }}>Rs. {feild.header_amount}</h4> */}
                                        </div>
                                        <div className="financial-table table-responsive">
                                            <Add_more_table {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} />
                                        </div>
                                    </React.Fragment>)
                                }
                            })}
                        </div>
                        <div className="row">
                            {drugs.map((feild, key) => {
                                if (feild.visible) {
                                    return (<React.Fragment key={key}>
                                        <div className="d-inline-flex w-100">
                                            <h4 className="data-label w-50" style={{ fontSize: 20 }}>{feild.title}</h4>
                                            {/* <h4 className="data-label w-50 text-right mr-3" style={{ fontSize: 20 }}>Rs. {feild.header_amount}</h4> */}
                                        </div>
                                        <div className="financial-table table-responsive">
                                            <Add_more_table {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} />
                                        </div>
                                    </React.Fragment>)
                                }
                            })}
                        </div>
                        <div className="row">
                            {procedures.map((feild, key) => {
                                if (feild.visible) {
                                    return (<React.Fragment key={key}>
                                        <div className="d-inline-flex w-100">
                                            <h4 className="data-label w-50" style={{ fontSize: 20 }}>{feild.title}</h4>
                                            {/* <h4 className="data-label w-50 text-right mr-3" style={{ fontSize: 20 }}>Rs. {feild.header_amount}</h4> */}
                                        </div>
                                        <div className="financial-table table-responsive">
                                            <Add_more_table {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} />
                                        </div>
                                    </React.Fragment>)
                                }
                            })}
                        </div>
                        <div className="row">
                            <div className="col text-center">
                                <button className="btn btn-success mr-2" onClick={() => { this.submitConsent() }}>Submit</button>
                                <button className="btn btn-next" onClick={() => this.setState({ commentModal: false, comments: null })}>Cancel</button>
                            </div>
                        </div>
                    </Spin>
                </Modal>

                <Modal
                    title=''
                    centere
                    footer={null}
                    width='95%'
                    zIndex='1021'
                    closable={false}
                    maskClosable={false}
                    visible={viewModal}>
                    <Spin spinning={loadding}>
                        <Tooltip title="Close"><CloseOutlined type="close" className="comments-popup-close" onClick={() => this.setState({ viewModal: false, comments: null })} /></Tooltip>
                        <h4 className="text-center pb-4">Consent Details</h4>
                        <div className="row pb-3">
                            <div className="col-12 my-auto p-0">
                                <h6 className="mb-0"> <Tooltip title="Patient Name">{patient_details.patient_name ? patient_details.patient_name : patient_name}</Tooltip> <span className="mx-3">|</span> <Tooltip title="UMR Number">{patient_details.umr_no ? patient_details.umr_no : '--'}</Tooltip> <span className="mx-3">|</span> <Tooltip title="IP Number">{patient_details.ip_no ? patient_details.ip_no : '--'}</Tooltip>
                                <span className="mx-3">|</span><Tooltip title="Ward Name">{patient_details.ward_name ? patient_details.ward_name : '--'}</Tooltip> <span className="mx-3">|</span><Tooltip title="Nurse Station Name">{patient_details.nurse_station_name ? patient_details.nurse_station_name : '--'}</Tooltip></h6>
                            </div>
                        </div>
                        <div className="row ">
                            <h4 className="data-label w-50 pt-3" style={{ fontSize: 20 }}>Investigations</h4>
                            <div className="financial-table table-responsive sticky-header" id="table">
                                <table className="table table-hover table-bordered mb-0 bg-white">
                                    <thead className="table-header-bg-color">
                                        {investigations_head.map((feild, key) => {
                                            if (feild.visible === true) {
                                                return (<th>{feild.text}</th>)
                                            }
                                        })}
                                    </thead>
                                    <tbody className="">
                                        {investigations_body
                                            .map((data, tkey) => {
                                                return (
                                                    <tr key={tkey}>
                                                        {investigations_head.map((head, Hkey) => {
                                                            if (head['name'] === 's_no') {
                                                                return (<td style={{ width: '5%' }}>{tkey + 1}</td>)
                                                            }
                                                            if (head['name'] === 'investigation_name') {
                                                                return (<td style={{ width: '28%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'general_price') {
                                                                return (<td style={{ width: '12%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'price') {
                                                                return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'approval_status') {
                                                                if(data[head['name']]!==null && data[head['name']]==='approve'){
                                                                    return (<td style={{ lineHeight: '1.2rem', textTransform: 'capitalize' }}>{(data[head['name']] !== null) ? data[head['name']]+'d' : 'NA'}</td>)
                                                                }else{
                                                                    return (<td style={{ lineHeight: '1.2rem', textTransform: 'capitalize' }}>{(data[head['name']] !== null) ? 'Rejected' : 'NA'}</td>)
                                                                }
                                                            }
                                                            if (head['name'] === 'reject_reason') {
                                                                return (<td style={{ width: '20%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'created_at') {
                                                                return (<td style={{ width: '15%' }}>{(data['created_at']) ? moment(data['created_at']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                                // return ( <td>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            return (
                                                                <td>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>
                                                            )
                                                        })}
                                                    </tr>
                                                )
                                            })
                                        }
                                        {(investigations_body && investigations_body.length === 0) && <React.Fragment>
                                            <tr>
                                                <td colSpan={investigations_head.length}>
                                                    <Empty description={
                                                        <span>
                                                            No Data
                                                        </span>
                                                    } />
                                                </td>
                                            </tr>
                                        </React.Fragment>}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="row ">
                            <h4 className="data-label w-50 pt-3" style={{ fontSize: 20 }}>Drugs</h4>
                            <div className="financial-table table-responsive sticky-header" id="table">
                                <table className="table table-hover table-bordered mb-0 bg-white">
                                    <thead className="table-header-bg-color">
                                        {drug_head.map((feild, key) => {
                                            if (feild.visible === true) {
                                                return (<th>{feild.text}</th>)
                                            }
                                        })}
                                    </thead>
                                    <tbody className="">
                                        {durg_body
                                            .map((data, tkey) => {
                                                return (
                                                    <tr key={tkey}>
                                                        {drug_head.map((head, Hkey) => {
                                                            if (head['name'] === 's_no') {
                                                                return (<td style={{ width: '5%' }}>{tkey + 1}</td>)
                                                            }
                                                            if (head['name'] === 'drug_name') {
                                                                return (<td style={{ width: '31%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'drug_price') {
                                                                return (<td style={{ width: '13%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'price') {
                                                                return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'approval_status') {
                                                                if(data[head['name']]!==null && data[head['name']]==='approve'){
                                                                    return (<td style={{ lineHeight: '1.2rem', textTransform: 'capitalize' }}>{(data[head['name']] !== null) ? data[head['name']]+'d' : 'NA'}</td>)
                                                                }else{
                                                                    return (<td style={{ lineHeight: '1.2rem', textTransform: 'capitalize' }}>{(data[head['name']] !== null) ? 'Rejected' : 'NA'}</td>)
                                                                }
                                                            }

                                                            if (head['name'] === 'reject_reason') {
                                                                return (<td style={{ width: '20%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'created_at') {
                                                                return (<td style={{ width: '15%' }}>{(data['created_at']) ? moment(data['created_at']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                            }
                                                            return (
                                                                <td>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>
                                                            )
                                                        })}
                                                    </tr>
                                                )
                                            })
                                        }
                                        {(durg_body && durg_body.length === 0) && <React.Fragment>
                                            <tr>
                                                <td colSpan={drug_head.length}>
                                                    <Empty description={
                                                        <span>
                                                            No Data
                                                        </span>
                                                    } />
                                                </td>
                                            </tr>
                                        </React.Fragment>}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="row ">
                            <h4 className="data-label w-50 pt-3" style={{ fontSize: 20 }}>Procedures</h4>
                            <div className="financial-table table-responsive sticky-header" id="table">
                                <table className="table table-hover table-bordered mb-0 bg-white">
                                    <thead className="table-header-bg-color">
                                        {procedures_head.map((feild, key) => {
                                            if (feild.visible === true) {
                                                return (<th>{feild.text}</th>)
                                            }
                                        })}
                                    </thead>
                                    <tbody className="">
                                        {procedures_body
                                            .map((data, tkey) => {
                                                return (
                                                    <tr key={tkey}>
                                                        {procedures_head.map((head, Hkey) => {
                                                            if (head['name'] === 's_no') {
                                                                return (<td style={{ width: '5%' }}>{tkey + 1}</td>)
                                                            }
                                                            if (head['name'] === 'procedure_name') {
                                                                return (<td style={{ width: '28%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'general_price') {
                                                                return (<td style={{ width: '12%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'price') {
                                                                return (<td style={{ width: '10%' }}>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'approval_status') {
                                                                if(data[head['name']]!==null && data[head['name']]==='approve'){
                                                                    return (<td style={{ lineHeight: '1.2rem', textTransform: 'capitalize' }}>{(data[head['name']] !== null) ? data[head['name']]+'d' : 'NA'}</td>)
                                                                }else{
                                                                    return (<td style={{ lineHeight: '1.2rem', textTransform: 'capitalize' }}>{(data[head['name']] !== null) ? 'Rejected' : 'NA'}</td>)
                                                                }
                                                            }
                                                            if (head['name'] === 'reject_reason') {
                                                                return (<td style={{ width: '20%' }}>{(data[head['name']] !== null) ? data[head['name']]: 'NA'}</td>)
                                                            }
                                                            if (head['name'] === 'created_at') {
                                                                return (<td style={{ width: '15%' }}>{(data['created_at']) ? moment(data['created_at']).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                            }
                                                            return (
                                                                <td>{(data[head['name']] !== null) ? data[head['name']] : 'NA'}</td>
                                                            )
                                                        })}
                                                    </tr>
                                                )
                                            })
                                        }
                                        {(procedures_body && procedures_body.length === 0) && <React.Fragment>
                                            <tr>
                                                <td colSpan={procedures_head.length}>
                                                    <Empty description={
                                                        <span>
                                                            No Data
                                                        </span>
                                                    } />
                                                </td>
                                            </tr>
                                        </React.Fragment>}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col text-center">
                                <button className="btn btn-next" onClick={() => this.setState({ viewModal: false })}>Close</button>
                            </div>
                        </div>
                    </Spin>
                </Modal>
            </div>
        )
    }
}

export default Consent_Patients_List;